import Details from '../../components/Details/Details';

export function DetailsRoute() {
  return <Details />;
}
